import { render, staticRenderFns } from "./filled-header.vue?vue&type=template&id=394f4190&"
import script from "./filled-header.vue?vue&type=script&lang=js&"
export * from "./filled-header.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PageHeaderNew: require('/web/components/layouts/PageHeaderNew.vue').default})
